import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectPrivai() {
  const SRC = 'https://cdn.privai.cl/parasitos/widget/cookie-banner.auto.js';
  (window as any).privaiConfig = {
    deploymentId: '1bf33d85-cd76-4d6f-a7e1-767e6d6a7c00',
    file_config_url: 'https://cdn.privai.cl/parasitos/config.json',
    apiBaseUrl: 'https://api.v2.privai.cl',
    cookieDomain: '.parasitos.cl',
    privacyCenterUrl: 'https://privacidad.parasitos.cl',
    language: 'es'
  };
  // 2) Inject the widget loader into <head>, once.
  if (!document.querySelector('script[src="' + SRC + '"]')) {
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    (document.head || document.documentElement).appendChild(s);
  }
})();
render(<App data-id="element-194" />, document.getElementById('root'));